import { getAxiosClient } from '../http.client';
export function useFeatureFlagsClient() {
    return new FeatureFlagsClient();
}
export class FeatureFlagsClient {
    apiClient;
    constructor() { }
    async client() {
        if (this.apiClient) {
            return this.apiClient;
        }
        this.apiClient = getAxiosClient("feature-flags");
        return this.apiClient;
    }
    // List all feature-flags
    async listFeatureFlags() {
        try {
            const client = await this.client();
            let url = '/';
            const response = await client.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Error listing feature flags:', error);
            throw error;
        }
    }
    // Create feature flag
    async createFeatureFlag(featureFlag) {
        try {
            const client = await this.client();
            const response = await client.post('/', featureFlag);
            return response.data;
        }
        catch (error) {
            console.error('Error creating feature flag:', error);
            throw error;
        }
    }
    // Toggle feature flag enabled/disabled
    async toggleFeatureFlag(id) {
        try {
            const client = await this.client();
            const response = await client.patch(`/${id}/toggle`);
            return response.data;
        }
        catch (error) {
            console.error('Error toggling feature flag:', error);
            throw error;
        }
    }
    // Delete feature flag
    async deleteFeatureFlag(id) {
        try {
            const client = await this.client();
            const response = await client.delete(`/${id}`);
            return response.data;
        }
        catch (error) {
            console.error('Error deleting feature flag:', error);
            throw error;
        }
    }
}
